export default __webpack_public_path__ + "static/media/SWT1170.34I-32286_-17791_0.e54864ae.jpg";